'use strict';

export default class Loader {
    constructor() { }

    fadeOut() {
        $('.loader').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: true
        });
    }

    fadeIn() {
        $('.loader').fadeIn({
            duration: 500,
            easing: 'easeOutExpo',
            queue: true
        });
    }
}
